const wrapper = "_35sw1xgttgc";
const table = "_35st1pot53g";

export { table, wrapper };
import "./printer.table.style.linaria.module.css";
//# sourceMappingURL=printer.table.style.js.map
